import { useEffect, useMemo, useState } from 'react';
import styles from './XPHPModal.module.css';
import api from '../../../../../api';
import { formatKST } from '../../../../../util';


const XPHPModal = ({account, marginTop, type, setUserModalPage}) => {
    const [xpLog, setXpLog] = useState([]);
    const [hpLog, setHpLog] = useState([]);

    async function getLogs(){
        const response = await api.get(`/user/xphp`);
        if(response.data){
            setXpLog(response.data.xpLog);
            setHpLog(response.data.hpLog);
        }
    }

    useEffect(()=>{
        if(account.hotpleId)
            getLogs();
        else
            setUserModalPage(0);
    },[])

    const logs = type === 'XP' ? xpLog : hpLog;
    const currentBalance = type === 'XP' ? account.xp.total_xp : account.hp;

    // 최신 로그부터 과거로 갈수록 현재 잔액에서 값을 빼며 “해당 시점 잔액” 계산
    const annotated = useMemo(() => {
        let running = Number(currentBalance) || 0; // 현재 시점 잔액
        return logs.map(l => {
        const value = Number(l.value || 0);
        const row = { ...l, balanceAfter: running }; // 이 로그 직후 잔액
        running -= value; // 과거로 한 스텝 이동
        return row;
        });
    }, [logs, currentBalance]);

    return (
        <div className={styles.container} style={{maxHeight: `calc(100dvh - ${marginTop + 24}px)`, marginTop: `${marginTop}px`}}>
            <div className={styles.contents}>
                <div className={styles.mainheader}>
                    <span className={styles.span}>{type} 보유량: </span>
                    <span>{currentBalance.toLocaleString()}{type}</span>
                </div>
                <div className={styles.listFrame}>
                    {annotated.map((log, idx) => (
                        <div className={styles.listRow} key={log.id ?? `${log.created_at}-${idx}`}>
                            <div className={styles.listTop}>
                                <div className={styles.name}>{log.description}</div>
                                <div className={log.value > 0 ? styles.plusValue : styles.minusValue}>
                                {log.value > 0 &&'+'}{Number(log.value || 0).toLocaleString()}{type}
                                </div>
                            </div>
                            <div className={styles.listTop}>
                                <div className={styles.listBottom}>{formatKST(log.created_at)}</div>
                                <div className={styles.listBottom}>{Number(log.balanceAfter).toLocaleString()}{type}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <></>
        </div>
    );
};

export default XPHPModal;